module.exports = fox._r("images/activity-card-join.png", __webpack_public_path__ + "_/_/_/root/images/activity-card-join.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/images/activity-card-join.png
// module id = 1071
// module chunks = 4